import { getLocalStorageItem } from './clientStorage';

const loglevel = require('loglevel');

/**
 * Get the Logger Object
 * Usage: Import the getLogger & get the log object [ var log = getLogger();]
 * Use the appropriate below methods to log mesages
 * 1.log.trace(msg)
 * 2.log.debug(msg)
 * 3.log.info(msg)
 * 4.log.warn(msg)
 * 5.log.error(msg)
 */
const getLogger = () => {
  // Loglevel set to 'ERROR' by default
  const level = getLocalStorageItem('loglevel:rcore') || 'ERROR';
  // get the Logger object
  const log = loglevel.getLogger('rcore');
  // set the loglevel
  log.setLevel(level);
  return log;
};

export default getLogger;
